import { useChartContext } from '../core/chart-context';
import { buildTicks } from '../core/scales';

export interface GridProps {
  /** Number of horizontal gridlines */
  tickCount?: number;
}

/** Dashed horizontal gridlines at the y-axis ticks. */
export const Grid = ({ tickCount = 5 }: GridProps) => {
  const { yScale, dimensions } = useChartContext();

  return (
    <g data-slot='chart-grid'>
      {buildTicks(yScale, tickCount).map(tick => (
        <line
          key={tick}
          x1={0}
          x2={dimensions.innerWidth}
          y1={yScale(tick)}
          y2={yScale(tick)}
          stroke='var(--color-border-base)'
          strokeDasharray='3 3'
        />
      ))}
    </g>
  );
};

Grid.displayName = 'Grid';
